export default "__VITE_ASSET__XD$hpmPK__"